import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { intlShape, injectIntl } from 'react-intl';
import { Field } from 'redux-form';
import _ from 'lodash';
import SelectField, { mapOptionsToSelectField } from '../../../shared-components/SelectField/SelectField';
import { isEmpty } from '../../../shared-components/FormElement/FormElementUtils';

const LOCALE_PREFIX = 'GB/components/CurrentUKResident/CurrentUKResident';

export class CurrentUKResident extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        residentListOptions: PropTypes.object.isRequired
    };

    render() {
        const { intl, residentListOptions } = this.props;

        return (
            <Field
                id="currentUkResident"
                name="currentUkResident"
                component={SelectField}
                optionList={mapOptionsToSelectField(residentListOptions)}
                required={true}
                label={intl.formatMessage({id: `${LOCALE_PREFIX}.userUkResidentLabel`})}
                placeholder={intl.formatMessage({id: `${LOCALE_PREFIX}.userUkResidentLabel`})}
                validate={[isEmpty(intl.formatMessage({id: `${LOCALE_PREFIX}.userUkResident-empty`}))]}
            />
        );
    }
}

export const mapStateToProps = state => ({
    // Grab the properties directly from the message object

    residentListOptions: _.get(state, `serverData.messages.${LOCALE_PREFIX}.userUkResidentList`)
});

export default connect(mapStateToProps)(injectIntl(CurrentUKResident));
